import React from 'react';
import { MapPin, Phone, Mail, Heart, Instagram, Youtube } from 'lucide-react';
import { Link } from 'react-router-dom';
import logo from '../../assets/footer_logo.png';

const Footer = () => {
  const quickLinks = [
    { name: 'Home', href: '/' },
    { name: 'Projects', href: '/projects' },
    { name: 'Gallery', href: '/gallery' },
    { name: 'About', href: '/about' },
    { name: 'FAQs', href: '/faqs' },
    { name: 'Careers', href: '/careers' },
    { name: 'Contact', href: '/contact' }
  ];

  return (  
    <footer className="bg-[var(--primarycolor)] text-white relative overflow-hidden">
      {/* Background Decorative Elements */}
      {/* <div className="absolute inset-0">
        <div className="absolute top-0 right-0 w-96 h-96 bg-red-600/30 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-80 h-80 bg-red-800/40 rounded-full blur-2xl"></div>
        <div className="absolute top-1/2 left-1/3 w-64 h-64 bg-red-500/20 rounded-full blur-xl"></div>
      </div> */}

      <div className="relative z-10">
        {/* Main Footer Content */}
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
          <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-12">
            
            {/* Brand Section */}
            <div className="lg:col-span-1">
              <img src={logo} alt="Dignity Retirement Village" className="w-40 h-auto mb-4" />
              
              <p className="text-red-100 text-sm leading-relaxed mb-6">
A premium retirement community offers a life of dignity, comfort, and wellness for your golden years.              </p>

              {/* Social Media */}
              <div className="flex gap-4">
                {[
                  { icon: Instagram, href: 'https://www.instagram.com/whitespaceproperties?igsh=MTAzdGh1eXVoNWFobQ==' },
                  { icon: Youtube, href: 'https://www.youtube.com/@whitespaceproperties' }
                ].map((social, index) => {
                  const SocialIcon = social.icon;
                  return (
                    <a
                      key={index}
                      href={social.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-10 h-10 bg-red-900 hover:bg-white rounded-lg flex items-center justify-center transition-all duration-300 group"
                    >
                      <SocialIcon className="w-5 h-5 text-white group-hover:text-red-700 transition-colors duration-300" />
                    </a>
                  );
                })}
              </div>
            </div>

            {/* Quick Links */}
            <div className="lg:col-span-1 md:mx-auto">
              <h4 className="text-xl font-semibold text-white mb-6">Quick Links</h4>
              <nav className="space-y-3">
                {quickLinks.map((link, index) => (
                  <Link
                    key={index}
                    to={link.href}
                    className="block text-red-100 hover:text-white text-sm font-medium transition-colors duration-300 transform"
                  >
                    {link.name}
                  </Link>
                ))}
              </nav>
            </div>

            {/* Contact Information */}
            <div className="lg:col-span-1">
              <h4 className="text-xl font-semibold text-white mb-6">Contact Info</h4>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <MapPin className="w-5 h-5 text-red-200 mt-0.5 flex-shrink-0" />
                  <div>
                    <p className="text-red-100 text-sm leading-relaxed">
                      5th Floor, Elite Arcade,
                      Kannur Road, Chakkorthkulam, Kozhikode,
                      Kerala 673011
                    </p>
                  </div>
                </div>
                
                <div className="flex items-center gap-3">
                  <Phone className="w-5 h-5 text-red-200 flex-shrink-0" />
                  <a href="tel:+918590442525" className="text-red-100 hover:text-white text-sm font-medium transition-colors duration-300">
                    +91 8590442525
                  </a>
                </div>
                
                <div className="flex items-center gap-3">
                  <Mail className="w-5 h-5 text-red-200 flex-shrink-0" />
                  <a href="mailto:whitespacepropertiesclt@gmail.com" className="text-red-100 hover:text-white text-sm font-medium transition-colors duration-300">
                    whitespacepropertiesclt@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-red-600 backdrop-blur-sm">
          <div className="max-w-7xl mx-auto px-6 md:px-12 py-6">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-red-200 text-sm text-center md:text-left">
                © 2025 Whitespace Properties LLP. All rights reserved. Designed by <a href="https://www.elzonex.com/" className='text-white hover:underline'>ElzoneX</a> Calicut.
              </p>
              
              {/* <div className="flex gap-6 text-xs text-red-200">
                <a href="#privacy" className="hover:text-white transition-colors duration-300">Privacy Policy</a>
                <a href="#terms" className="hover:text-white transition-colors duration-300">Terms & Conditions</a>
                <a href="#rera" className="hover:text-white transition-colors duration-300">RERA Details</a>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;